import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Brain, Plus, Minus, X, Maximize2 } from 'lucide-react';
import ContextChip from '../shared/ContextChip';

const ChatHeader = ({
  onClose,
  onMinimize,
  onNewChat,
  connectionStatus,
  isMinimized,
  context,
}) => {
  const { t } = useTranslation();

  const statusKey =
    connectionStatus === 'connected'
      ? 'aiTutoring.statusOnline'
      : connectionStatus === 'error'
        ? 'aiTutoring.statusError'
        : connectionStatus === 'disconnected'
          ? 'aiTutoring.statusOffline'
          : 'aiTutoring.statusConnecting';

  return (
    <div className="ai-tutor-header">
      <div className="ai-tutor-header-info">
        <div className="ai-tutor-header-avatar" aria-hidden>
          <Brain size={22} strokeWidth={2} />
        </div>
        <div className="ai-tutor-header-text">
          <h3>{t('aiTutoring.qoreAI')}</h3>
          <p className={`ai-tutor-status ai-tutor-status--${connectionStatus || 'connecting'}`}>
            {t(statusKey)}
          </p>
        </div>
      </div>

      {!isMinimized && context && (
        <div className="ai-tutor-header-context">
          <ContextChip context={context} />
        </div>
      )}

      <div className="ai-tutor-header-actions">
        {!isMinimized && (
          <>
            <Link
              to="/aitutoring"
              className="ai-tutor-header-btn"
              title={t('aiTutoring.openFullPage')}
              aria-label={t('aiTutoring.openFullPage')}
            >
              <Maximize2 size={16} />
            </Link>
            <button
              type="button"
              className="ai-tutor-header-btn"
              onClick={onNewChat}
              title={t('aiTutoring.newChat')}
              aria-label={t('aiTutoring.newChat')}
            >
              <Plus size={16} />
            </button>
          </>
        )}
        <button
          type="button"
          className="ai-tutor-header-btn"
          onClick={onMinimize}
          title={isMinimized ? t('aiTutoring.expand') : t('aiTutoring.minimize')}
          aria-label={isMinimized ? t('aiTutoring.expand') : t('aiTutoring.minimize')}
        >
          <Minus size={16} />
        </button>
        <button
          type="button"
          className="ai-tutor-header-btn ai-tutor-header-btn--close"
          onClick={onClose}
          title={t('aiTutoring.close')}
          aria-label={t('aiTutoring.close')}
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default ChatHeader;